
<template>
	<div class="tip-link">
		<a href="#" @click="handleShow">{{linkText}}</a>
		<div>
			<div class="tip-text" v-if="showTip">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'TipLink',
		props: ['linkText'],
		filters: {},
		data(){
			return {
				showTip: false,
			};
		},
		methods: {
			handleShow(e){
				this.showTip = !this.showTip;

				if (this.showTip) {
					window.addEventListener('click', this.documentClick, true);
					return;
				}

				this.removeListeners();
			},
			documentClick(e){
				let target = e.target.offsetParent || e.target;
				const isTrigger = target.classList.contains('tip-text');

				if (isTrigger) {
					//return out and let the trigger hide/show menu
					return;
				}

				if (this.showTip) {
					this.showTip = false;
					this.removeListeners();
				}
			},
			removeListeners() {
				window.removeEventListener('click', this.documentClick, true);
			},
			destroyed() {
				window.removeEventListener('click', this.documentClick, true);
			}

		}
	};
</script>

<style scoped>
	.tip-link{
		position:relative;
	}
	.tip-link p {
		margin: 0;
	}
	.tip-text::after {
		content: " ";
		position: absolute;
		bottom: 100%;  /* At the top of the tooltip */
		left: 5%;
		margin-left: -5px;
		border-width: 5px;
		border-style: solid;
		border-color: transparent transparent black transparent;
		line-height: 1.5;
		}

	.tip-link .tip-text{
		/* display:none; */
		position:relative;
		margin-top:10px;
		position:absolute;
		width: 200px;
		background-color: black;
		color:white;
		padding: 10px;
		border-radius:3px;
	}
	/* .tip-link:hover .tip-text{
		display:block;
	} */

	.tip-text p {
		margin-bottom:10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/TipLink.vue